// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3rwb7","loaderOuter":"PageOverlayLoader_loaderOuter__2rpiR"};